import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { compose } from 'recompose';

const enhance = compose(injectIntl);

const VehicleMaxHeight = React.memo(({ intl, container_height }) => {
  const t = intl.messages;
  return (
    !!container_height && (
      <Fragment>
        {container_height} {t.units.m}
      </Fragment>
    )
  );
});

VehicleMaxHeight.propTypes = {
  intl: PropTypes.object.isRequired,
  container_height: PropTypes.number,
};

export default enhance(VehicleMaxHeight);
